export const QUOTE_STATUS_COLORS: Record<string, string> = {
  pending_service_provider: 'blue',
  pending_customer: 'orange',
  accepted: 'green',
  customer_rejected: 'red',
  service_provider_rejected: 'volcano',
};

export const getQuoteStatusLabel = (status: string, t: (key: string) => string): string => {
  const map: Record<string, string> = {
    pending_service_provider: t('quotes.statusPendingSP'),
    pending_customer: t('quotes.statusPendingCustomer'),
    accepted: t('quotes.statusAccepted'),
    customer_rejected: t('quotes.statusCustomerRejected'),
    service_provider_rejected: t('quotes.statusSPRejected'),
  };
  return map[status] || status;
};
